// https://scaleflex.github.io/js-cloudimage-before-after

import $ from "jquery";

import CIBeforeAfter from "js-cloudimage-before-after";

import baseClass from "../base/base";
import generalTools from "../base/tools";

// ------------------------------------
baseClass.OnReadyArrAdd(function () {
  // -----------------------------------

  $(".js_imgbefaft").each((_, el) => {
    const $el = $(el);
    if ($el.hasClass("imgbefaft-true")) return;
    $el.addClass("imgbefaft-true");

    let id = $el.attr("id");
    id = id ? id : 'id_' + generalTools.uuidv4();
    $el.attr("id", id);

    const beforeSrc = $el.data("beforesrc");
    const afterSrc = $el.data("aftersrc");

    if (!beforeSrc || !afterSrc) return;

    // 🔥 helper pentru conversii
    const getBool = (val, def = false) => {
      if (val === undefined) return def;
      return val === true || val === "true" || val === 1 || val === "1";
    };

    const getNum = (val, def = null) => {
      if (val === undefined) return def;
      return Number(val);
    };

    // 🔹 toate opțiunile
    const options = {
      beforeSrc,
      afterSrc,

      // direcția sliderului
      orientation: $el.data("orientation") || "horizontal",
      // horizontal | vertical

      // poziția inițială (0-100)
      startingPosition: getNum($el.data("startingposition"), 50),

      // interacțiuni
      hover: getBool($el.data("hover"), false),
      click: getBool($el.data("click"), true),
      draggable: getBool($el.data("draggable"), true),

      // infinite move (loop)
      zoom: getBool($el.data("zoom"), false),
      fullscreenButton: getBool($el.data("fullscreenButton"), false),
      infiniteMove: getBool($el.data("infinite"), false),

      // UI
      animate: getBool($el.data("animate"), false),
      showHandle: getBool($el.data("showhandle"), true),
      // showLabels: getBool($el.data("showlabels"), false),
      labels: getBool($el.data("labels"), false),
      handleStyle: $el.data("handleStyle") || "",

      // labels
      beforeLabel: $el.data("beforelabel") || "Before",
      afterLabel: $el.data("afterlabel") || "After",

      // styling
      handleColor: $el.data("handlecolor") || "#ffffff",
      handleOpacity: getNum($el.data("handleopacity"), 0.8),

      // responsive / behavior
      smoothTransition: getBool($el.data("smooth"), true),
    };

    new CIBeforeAfter("#" + id, options);
  });

  // ------------------------------------
});
